import InfoIcon from '@mui/icons-material/Info';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { HOME_URL } from '../../scripts/navigationItems';

const ErrorPage = () => (
	<Container align='center' sx={{ my: { xs: 3, md: 5 } }}>
		<InfoIcon sx={{ width: '78px', height: '78px' }} />
		<Typography variant='h5' component='h1'>
			We&apos;re sorry, something went wrong.
		</Typography>
		<Typography my={{ xs: 1, md: 2 }} variant='body3' gutterBottom>
			We&apos;re unable to load the page at this time. Please try again
			later.
		</Typography>
		<Button
			variant='contained'
			component={RouterLink}
			to={HOME_URL}
			target='_self'
		>
			Back to Home
		</Button>
	</Container>
);

export default ErrorPage;
